const websocketUrl = () => {
  return process.env.NODE_ENV == "development" ? "wss://xj-live.e-class.me/wss" : localStorage.getItem("websocket_host");
};

/** 阿里云 NLS Token 接口（与后端约定一致） */
const ALIYUN_NLS_CREATE_TOKEN_URL = "api/aliyun/nls/createToken";
/** 在过期时间前提前刷新（秒），避免边界时刻请求仍带上将失效的 token */
const ALIYUN_NLS_EXPIRE_BUFFER_SEC = 60;

let nlsTokenCache = {
  token: "",
  /** 服务端返回的 Unix 时间戳（秒），表示 token 失效时刻 */
  expireTimeSec: 0,
};
/** 并发请求时复用同一 Promise */
let nlsTokenInflight = null;

/**
 * 从后端拉取 NLS Token 并写入内存缓存
 * @returns {Promise<string>}
 */
async function fetchAliyunNlsTokenFromApi() {
  if (typeof fetch === "undefined") {
    throw new Error("当前环境不支持 fetch");
  }
  const auth =
    typeof localStorage !== "undefined" ? localStorage.getItem("studentToken") || localStorage.getItem("Authorization") : "";
  const res = await fetch(ALIYUN_NLS_CREATE_TOKEN_URL, {
    method: "GET",
    headers: {
      "Cache-Control": "no-cache",
      ...(auth ? { Authorization: auth } : {}),
    },
    credentials: "same-origin",
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json.msg || `Token 接口 HTTP ${res.status}`);
  }
  if (json.code !== 200 || !json.data || !json.data.token) {
    throw new Error(json.msg || "Token 获取失败");
  }
  const token = String(json.data.token).trim();
  const expireRaw = json.data.expire_time;
  let expireTimeSec =
    expireRaw != null && Number(expireRaw) > 0 ? Math.floor(Number(expireRaw)) : Math.floor(Date.now() / 1000) + 300;
  /* 若误传毫秒级时间戳（> 1e11），转为秒 */
  if (expireTimeSec > 1e11) {
    expireTimeSec = Math.floor(expireTimeSec / 1000);
  }
  nlsTokenCache = { token, expireTimeSec };
  return token;
}

function isAliyunNlsTokenCacheValid() {
  if (!nlsTokenCache.token) return false;
  const nowSec = Math.floor(Date.now() / 1000);
  return nowSec < nlsTokenCache.expireTimeSec - ALIYUN_NLS_EXPIRE_BUFFER_SEC;
}

/**
 * 获取阿里云 NLS 实时语音识别 Token（带缓存与过期自动刷新）
 * @returns {Promise<string>}
 */
const getAliyunNlsToken = async () => {
  if (isAliyunNlsTokenCacheValid()) {
    return nlsTokenCache.token;
  }
  if (nlsTokenInflight) {
    return nlsTokenInflight;
  }
  nlsTokenInflight = fetchAliyunNlsTokenFromApi()
    .then((t) => t)
    .finally(() => {
      nlsTokenInflight = null;
    });
  return nlsTokenInflight;
};

/** 供登出等场景主动清空，避免使用旧账号缓存 */
export function clearAliyunNlsTokenCache() {
  nlsTokenCache = { token: "", expireTimeSec: 0 };
  nlsTokenInflight = null;
}

export default {
  appName: "直播电商运营实训系统",
  websocketUrl,
  aliyunNls: {
    wsUrl: process.env.VUE_APP_ALIYUN_NLS_WS_URL || "wss://nls-gateway-cn-shanghai.aliyuncs.com/ws/v1",
    appkey: process.env.VUE_APP_ALIYUN_NLS_APPKEY || "Eney7YHStO509nUO",
  },
  getAliyunNlsToken,
};
